import React, { useEffect, useState } from 'react';
import logo from '../assets/logo.png';
import Autosuggest from 'react-autosuggest';
import { Link, useLocation, useNavigate } from 'react-router-dom';
// import './FeedHeader.css';
import SearchIcon from '../assets/search-2.svg';
import AboutIcon from '../assets/information-button.png';
import profilePicture from "../assets/default_pfp.png"
import Hamburger from '../assets/hamburger-white.png';
import translations from './translation.js';
import Level from './Level.jsx';


const Header = ({onValue}) => {
  const [value, setValue] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [userData, setUserData] = useState({});
  const [username, setUsername] = useState('');
  const [userID, setUserID] = useState('');
  const [picture, setPicture] = useState('');
  const [searchHistory, setSearchHistory] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const [isHovered, setIsHovered] = useState(false);
  const [LanguageMenuopen, setLanguageMenuopen] = useState(false); // New state
  const navigate = useNavigate();
  const [exp, setExp] = useState(0);

  const currentLanguage = localStorage.getItem('selectedLanguage') || "en";

  const handleLanguageChange = (e) => {
    setSelectedLanguage(e.target.value);
    localStorage.setItem('selectedLanguage', e.target.value);
    switch (e.target.value) {
    case "en":
      window.location.reload();
        break;
    case "ch":
      window.location.reload();
        break;
    }
};

  const updateUserSearchHistory = async (userId, newSearchHistory) => {
    try {
      const updateResponse = await fetch(
        `${process.env.REACT_APP_API_PATH}/users/${userId}`,
        {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
          },
          body: JSON.stringify({
            attributes: {
              searchHistory: newSearchHistory,
              username: username,
              picture: picture,
            },
          }),
        }
      );

      if (updateResponse.ok) {
        console.log('Search history updated successfully');
      } else {
        console.error('Failed to update search history');
      }
    } catch (error) {
      console.error('Error updating search history:', error);
    }
  };

  useEffect(() => {
    document.title = 'TeamUp';
    const fetchUserData = async () => {
      try {
        const userResponse = await fetch(
          `${process.env.REACT_APP_API_PATH}/users/${sessionStorage.getItem('user')}`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            },
          }
        );

        if (userResponse.ok) {
          const userResult = await userResponse.json();
          setUserData(userResult);
          setUsername(userResult.attributes.username);
          setExp(userResult.attributes.exp);
          setPicture(userResult.attributes.picture);
          setUserID(userResult.id);
          setSearchHistory(userResult.attributes.searchHistory);
        } else {
          console.error('Failed to fetch user data');
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };

    fetchUserData();
  }, []);

  const getSuggestions = (inputValue) => {
    const inputLength = inputValue.length;

    return inputLength === 0
      ? []
      : searchHistory.filter(
        (item) => item.toLowerCase().includes(inputValue.toLowerCase())
      );
  };

  const onChange = (event, { newValue }) => {
    setValue(newValue);
    onValue(newValue)
  };

  const onSuggestionsFetchRequested = ({ value }) => {
    setSuggestions(getSuggestions(value));
  };

  const onSuggestionsClearRequested = () => {
    setSuggestions([]);
  };

  const onEnterPress = (event) => {
    if (event.key === 'Enter') {
      const newSearchHistory = [...searchHistory, value];
      setSearchHistory(newSearchHistory);
      updateUserSearchHistory(userData.id, newSearchHistory);
      setValue(''); // Reset the value to an empty string
    }
  };

  const toggleMobileNav = () => {
    const mobileNav = document.getElementById("mobile-nav");
    const currentDisplay = window.getComputedStyle(mobileNav).display;

    if (window.innerWidth > 1050) {
      mobileNav.style.display = "none";
    } else {
      mobileNav.style.display = currentDisplay === "none" || !currentDisplay ? "flex" : "none";
    }
  };

  const toggleUserMenu = () => {
    const userMenu = document.getElementById("user-menu");
    const currentDisplay = window.getComputedStyle(userMenu).display;
    userMenu.style.display = currentDisplay === "none" || !currentDisplay ? "flex" : "none";
  };
  const toggleLanguageMenu = () => {
    setLanguageMenuopen(!LanguageMenuopen);
  };


  const inputProps = {
    placeholder: translations[currentLanguage].search_text,
    value,
    onChange,
    onKeyPress: onEnterPress,
    id: 'search',
  };

  const signOut = () => {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("user");
    navigate("/");
  };

  const highlightActive = (path) => {
    // check if current link is nav link and add class active-tab to that link
    // const location = useLocation();
    return window.location.pathname === path ? 'active-tab' : '';
  };

  return (
    <header>
      <div className="header">
        <div className='header-logo'>
          <Link to="/feed">
            <img src={logo} alt="logo" />
          </Link>
        </div>

        <div className="fsearch desktop">
          <img src={SearchIcon} alt="Search Icon" className="fs-icon" />
          <Autosuggest
            suggestions={suggestions}
            onSuggestionsFetchRequested={onSuggestionsFetchRequested}
            onSuggestionsClearRequested={onSuggestionsClearRequested}
            getSuggestionValue={(suggestion) => suggestion}
            renderSuggestion={(suggestion) => <div>{suggestion}</div>}
            inputProps={inputProps}
          />
        </div>

        <Link to="/profilepagelist" className='about-us desktop' title='About Us'>
          <img src={AboutIcon} alt="About Us" />
        </Link>

        <button onClick={toggleUserMenu} style={{ background: "none", border: "none" }}>
          <div className="userbox">
            <img
              src={picture || profilePicture}
              alt="your profile"
              className="h-prof"
            />
            <div className="h-txt-box">
              <h3>{username || userData.email}</h3>
              <div className='headerLevel'>
                <Level experience={exp} language={currentLanguage} />
              </div>
            </div>
          </div>
          <div id="user-menu">
            <Link to={"/user/" + userID}>{translations[currentLanguage].view_profile}</Link>
            <Link to="/" onClick={signOut}>{translations[currentLanguage].logout}</Link>
            <button onClick={toggleLanguageMenu} style={{ background: "none", border: "none", position: "relative", color: "#d1b140" }}>{translations[currentLanguage].language}</button>
          </div>
        </button>
        {LanguageMenuopen && (
          <div id="language-menu" className="language-modal">
            <button onClick={toggleLanguageMenu} className='header_close_button'>X</button>
            <button onClick={() => { handleLanguageChange({ target: { value: "en" } }); toggleLanguageMenu(); }} className='header_lan_button' >{translations[currentLanguage].english}</button>
            <button onClick={() => { handleLanguageChange({ target: { value: "ch" } }); toggleLanguageMenu(); }} className='header_lan_button' >{translations[currentLanguage].chinese}</button>
          </div>)}
      </div>
      <div className="mobile-nav mobile">
        <div className="fsearch mobile">
          <img src={SearchIcon} alt="Search Icon" className="fs-icon" />
          <Autosuggest
            suggestions={suggestions}
            onSuggestionsFetchRequested={onSuggestionsFetchRequested}
            onSuggestionsClearRequested={onSuggestionsClearRequested}
            getSuggestionValue={(suggestion) => suggestion}
            renderSuggestion={(suggestion) => <div>{suggestion}</div>}
            inputProps={inputProps}
          />
        </div>
        <button className="show-nav mini" onClick={toggleMobileNav}><img src={Hamburger} alt="menu" />{translations[currentLanguage].menu}</button>
        <button className="show-nav tiny" onClick={toggleMobileNav}><img src={Hamburger} alt="menu" /></button>
      </div>
      <nav className='desktop'>
        <Link to="/discover" className={highlightActive('/discover')}>
          {translations[currentLanguage].discover}
        </Link>
        <Link to="/feed" className={highlightActive('/feed')}>
          {translations[currentLanguage].feed}
        </Link>
        <Link to="/rankings" className={highlightActive('/rankings')}>
          {translations[currentLanguage].ranking}
        </Link>
        <Link to="/find-players" className={highlightActive('/find-players')}>
          {translations[currentLanguage].find}
        </Link>
      </nav>

      <nav className='mobile' id="mobile-nav">
        <Link to="/discover" className={highlightActive('/discover')}>
          {translations[currentLanguage].discover}
        </Link>
        <Link to="/feed" className={highlightActive('/feed')}>
          {translations[currentLanguage].feed}
        </Link>
        <Link to="/rankings" className={highlightActive('/rankings')}>
          {translations[currentLanguage].ranking}
        </Link>
        <Link to="/find-players" className={highlightActive('/find-players')}>
          {translations[currentLanguage].find}
        </Link>
        <hr />
        <Link to="/profilepagelist">
          {translations[currentLanguage].about}
        </Link>
      </nav>

    </header>
  );
};

export default Header;
